import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const SLICE_NAME = "home";

export const APIURL = process.env.REACT_APP_API_URL;
export const ContactFormAPIURL = process.env.REACT_APP_ENV === "prod" ? process.env.REACT_APP_API_URL : 'https://jb-glass-qa-apis.jarvistechnolabs.com'

// Async thunk to fetch data
export const fetchStatisticsCount = createAsyncThunk(
  `${SLICE_NAME}/fetchStatisticsCount`,
  async () => {
    try {
      const response = await axios.get(
        `${APIURL}/web/website/statistics-count`
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
);

export const sendOTP = createAsyncThunk(
  `${SLICE_NAME}/sendOTP`,
  async (reqObj: any) => {
    try {
      const response = await axios.post(
        `${APIURL}/website/create-quotation`,
        reqObj
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
);

export const verifyOTP = createAsyncThunk(
  `${SLICE_NAME}/sendOTP`,
  async (reqObj: any) => {
    try {
      const response = await axios.post(`${APIURL}/website/verify-otp`, reqObj);
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const getQuotationAPI = createAsyncThunk(
  `${SLICE_NAME}/getQuotationAPI`,
  async (reqObj: any) => {
    try {
      const response = await axios.post(
        `${APIURL}/website/get-quotation`,
        reqObj
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const getCitiesStatesData = createAsyncThunk(
  `${SLICE_NAME}/getQuotationAPI`,
  async () => {
    try {
      const response = await axios.get(`${APIURL}/website/get-states-cities`);
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const getSubCategoryList = createAsyncThunk(
  `${SLICE_NAME}/getSubCategoryListAPI`,
  async () => {
    try {
      const response = await axios.get(
        `${APIURL}/web/glass-categories-settings/fetch-subcategory-list`
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const dynamicGlassCataloguesPDF = createAsyncThunk(
  `${SLICE_NAME}/dynamicGlassCataloguesPDFAPI`,
  async (subCategoryId: string) => {
    try {
      const response = await axios.get(
        `${APIURL}/web/download/dynamic-glass-catalogues/`,
        { params: { subCategoryId } }
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const addContact = createAsyncThunk(
  `${SLICE_NAME}/addContact`,
  async (reqObj: any) => {
    try {
      const response = await axios.post(
        `${ContactFormAPIURL}/app/jb-connect/website/add-contact`,
        reqObj
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const APIGetStateDDL = createAsyncThunk(
  `${SLICE_NAME}/APIGetStateDDL`,
  async () => {
    const stateId: number = 0;
    try {
      const response = await axios.get(
        `${ContactFormAPIURL}/web/states/get-ddl/${stateId}`
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

export const APIGetCityDDL = createAsyncThunk(
  `${SLICE_NAME}/APIGetCityDDL`,
  async (stateId: number) => {
    const cityId: number = 0;
    try {
      const response = await axios.get(
        `${ContactFormAPIURL}/web/cities/get-ddl/${stateId}/${cityId}`
      );
      return response.data;
    } catch (err: any) {
      console.error(err.response.data.message);
      return err.response.data;
    }
  }
);

const initialState = {
  statisticsCount: {},
  citiesStateData: [],
  isLoadingCitiesStateData: false,
  loading: false,
  subCategoryData: [],
  glassCataloguesPDF: {},
  loadingPDF: false,
  stateDDL: [],
  cityDDL: [],
};

// Create the slice
const homeSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStatisticsCount.fulfilled, (state, action: any) => {
      state.statisticsCount = action.payload.data.data;
    });
    builder.addCase(getCitiesStatesData.pending, (state) => {
      state.isLoadingCitiesStateData = true;
    });
    builder.addCase(getCitiesStatesData.fulfilled, (state, action: any) => {
      state.isLoadingCitiesStateData = false;
      state.citiesStateData = action.payload.data.data;
    });
    builder.addCase(getCitiesStatesData.rejected, (state) => {
      state.isLoadingCitiesStateData = false;
    });
    builder.addCase(sendOTP.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendOTP.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(sendOTP.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getSubCategoryList.fulfilled, (state, action: any) => {
      state.subCategoryData = action.payload.data.data;
    });
    builder.addCase(dynamicGlassCataloguesPDF.pending, (state) => {
      state.loadingPDF = true;
    });
    builder.addCase(
      dynamicGlassCataloguesPDF.fulfilled,
      (state, action: any) => {
        state.glassCataloguesPDF = action.payload.data.data;
        state.loadingPDF = false;
      }
    );
    builder.addCase(dynamicGlassCataloguesPDF.rejected, (state, action) => {
      state.loadingPDF = false;
    });
    builder.addCase(APIGetStateDDL.fulfilled, (state, action: any) => {
      state.stateDDL = action.payload.data.data;
    });
    builder.addCase(APIGetCityDDL.fulfilled, (state, action: any) => {
      state.cityDDL = action.payload.data.data;
    });
  },
});

// Export actions and reducer
export default homeSlice.reducer;
